var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"container"},[_c('h1',[_vm._v("Preview Image")]),_c('AppSheetPreviewImage',{attrs:{"preview-image-url":"https://aurora.dev.web3d.page/data/imageforimagegallery/2020/07/image/b9b8011b90db496a893d614b1620ea83"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }